import React, { InputHTMLAttributes } from 'react';
import styles from '../../components/FormElements/Forms.module.scss';

interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  name: string;
  label: string;
  labelHidden?: boolean;
}

export const Input: React.FC<InputProps> = ({ name, label, labelHidden = true, ...attributes }) => {
  return (
    <div className={styles['form__group']}>
      <label className={`${styles['form__label']} ${labelHidden ? styles['form__label--hidden'] : ''}`} htmlFor={name}>
        {label}
      </label>
      <input className={styles['form__control']} id={name} {...attributes} />
    </div>
  );
};
